import {useCallback} from 'react';
import {useRouter} from 'next/router';
import {useAuth} from '../auth';
import {cancelSubscription} from '../pricing';

export const useUnsubscribe = () => {
    const router = useRouter();
    const auth = useAuth();
    const user = auth?.user;
    const subscription = user?.subscription;
    const futureSubscription = user?.futureSubscription;

    const subscriptionId = futureSubscription?.id || subscription?.id;

    const unsubscribe = useCallback(() => {
        const confirmed = window.confirm('Cancel active subscription?');

        if (!confirmed) {
            return;
        }

        cancelSubscription(subscriptionId).then((response) => {
            if (response?.status === 'SUCCESS') {
                router.reload(window.location.pathname)
            }
        }).catch(err => {
            console.error(err);
        })
    }, [subscriptionId]);

    return unsubscribe;
}
